<template>
    <div>
        <ContentRiskActions
            v-slot="contentRiskProps"
        >
            <AutomationEmailEditorPage
                v-bind="{...$props, ...contentRiskProps}"
                @closeCampaignUnlayerEmailBuilderModal="$emit('closeCampaignUnlayerEmailBuilderModal')"
                @campaignUnlayerEmailReady="$emit('campaignUnlayerEmailReady')"
                @campaignUnlayerEmailNotReady="$emit('campaignUnlayerEmailNotReady')"
            />
        </ContentRiskActions>
    </div>
</template>

<script>
import AutomationEmailEditorPage from './AutomationEmailEditorPage';
import ContentRiskActions from './ContentRiskActions';

export default {

    components: {
        AutomationEmailEditorPage,
        ContentRiskActions,
    },

    props: {
        marketingEmailId: {
            type: String,
        },
        funnelId: {
            type: String,
            default: '',
        },
        title: {
            type: String,
        },
        unlayerProjectId: {
            type: String,
            required: true,
        },
        appId: {
            type: String,
            required: true,
        },
        environment: {
            type: String,
            required: true,
        },
        userId: String,
        bookingLinkHostname: String,
        campaignEmailPreviewEnabled: Boolean,
        filterMyTemplatesEnabled: Boolean,
        replyToEnabled: Boolean,
        i18nEnabled: Boolean,
        unlayerAiToolsEnabled: Boolean,
        unlayerSmartMergeTagsEnabled: Boolean,
        wrapSenderDisplayNameWithQuotesEnabled: Boolean,
        showVerifiedDomainsNewKeysOnlyEnabled: Boolean,
        fromSelectionEnabled: Boolean,
        unlayerBuilderVersionOverride: String,
        useUnlayerBuilderVersionOverrideEnabled: Boolean,
        isKonva: Boolean,
        isMaxClassic: Boolean,
        isCellReady: Boolean,
        previewLogoBrandingCenterEnabled: Boolean,
        unlayerEmailLogoToolEnabled: Boolean,
        unlayerFileDownloadHyperlinksEnabled: Boolean,
        templateSearchEnabled: Boolean,
        autoOpenContent: Boolean,
        userSignatureMergeFieldEnabled: Boolean,
    },


};
</script>